import { HttpContextToken, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { StorageService } from 'core-tsi';
import { EMPTY, finalize, Observable, share } from 'rxjs';

let _activeRequest = 0
let _activeRequestKeys = new Set<string>();
const _activeGetRequests = new Map<string, Observable<HttpEvent<unknown>>>();

export function incrementRequest() {
  _activeRequest++;
  if (_activeRequest === 1) showSpinner()
}

export function decrementRequest() {
  _activeRequest--;
  if (_activeRequest === 0) hideSpinner()
}

export function showSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = false
  }
}

export function hideSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = true
  }
}

export const TOAST_LOADING = new HttpContextToken(() => false);
export const SKIP_LOADING = new HttpContextToken(() => false);
export const ONLY_BEARER = new HttpContextToken<boolean>(() => false);

export const PeticionApiInterceptor: HttpInterceptorFn = (req, next) => {
  // const toast = inject(ToastService)
  const skipSpinner = req.context.get(SKIP_LOADING);
  const useToast = req.context.get(TOAST_LOADING);
  const bearer = req.context.get(ONLY_BEARER)

  const request = bearer
    ? req.clone({ setHeaders: { Authorization: `Bearer ${StorageService.getSession().token}` } })
    : req

  if (skipSpinner || useToast) {
    return next(request);
  }

  const isFormData = req.body instanceof FormData;
  const key = req.method + req.urlWithParams + JSON.stringify(req.body ?? {});
  const esGet = req.method === 'GET'
  const getEnCurso = esGet ? _activeGetRequests.get(key) : undefined
  if (getEnCurso) {
    return getEnCurso;
  }
  if (!isFormData) {
    if (_activeRequestKeys.has(key)) {
      return EMPTY;
    }
    _activeRequestKeys.add(key);
  }

  if (_activeRequest == 0) {
    showSpinner()
  }
  _activeRequest++

  const peticion = next(request).pipe(
    finalize(() => {
      if (!isFormData) _activeRequestKeys.delete(key);
      _activeGetRequests.delete(key);
      _activeRequest--
      if (_activeRequest == 0) {
        hideSpinner()
      }
    }),
    share()
  )
  if (esGet) {
    _activeGetRequests.set(key, peticion);
  }
  return peticion
}